import React from 'react';
import PropTypes from "prop-types";
import { connect } from 'react-redux';

import ReportProblemFlag from '../shared/ReportProblemFlag';
import FeedbackModal from '../shared/FeedbackModal';

class OpeningHeader extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { opening } = this.props;

    return (
      <>
        <div className="alert alert-primary" role="alert">
          <strong> {opening.name}</strong>
          <ReportProblemFlag />
        </div>
        <FeedbackModal />
      </>
    );
  }
}

OpeningHeader.propTypes = {
  opening: PropTypes.shape({
    name: PropTypes.string,
  }).isRequired,
};

function mapStateToProps(state) {
  const { opening } = state;

  return { opening };
}

export default connect(mapStateToProps)(OpeningHeader);